import PropTypes from "prop-types"
import React, { useContext } from "react"
import AppContext from "~/contexts/App"
import CourseContext from "~/contexts/Course"

import { Button, Typography } from "@material-ui/core"
import dayjs from "dayjs"
import Box from "~/components/Common/Box"
import useStyles from "./styles"

const DateTime = ({ disablePicker }) => {
  // disablePicker gives T if course is published, unpublished, or archived - only available to draft

  const classes = useStyles()

  const {
    // setDebouncedDetails,
    // debouncedDetails,
    dateValue,
    setDateValue,
    tryPublish,
    setTryPublish,
    setPublishDateFunc,
    disabledSave,
    course,
  } = useContext(CourseContext)

  const { openDialog, closeDialog } = useContext(AppContext)

  const handleClose = () => {
    closeDialog("confirmationTypingDialog", true)
  }

  const handleDateSelection = () => {
    let data = {
      title: "Confirm Publish Date",
      subtitle: "",
      type: "publish",
      confirmWord: "ship it",
    }
    openDialog("confirmationTypingDialog", data, false)
      .then(() => {
        setPublishDateFunc(dateValue)
        setDateValue(dateValue)
        handleClose()
      })
      .catch(() => {
        setTryPublish(false)
        setDateValue(
          course.publish_date
            ? dayjs(course.publish_date).format("YYYY-MM-DDTHH:mm")
            : "",
        )
      })
  }

  const handleClearDate = () => {
    let data = {
      title: "Confirm Cancel Scheduled Publish Date",
      subtitle: "",
      type: "schedule",
      confirmWord: "delete",
    }
    openDialog("confirmationTypingDialog", data, false)
      .then(() => {
        setPublishDateFunc(null)
        setDateValue("")
        setTryPublish(false)
        handleClose()
      })
      .catch(() => {
        setTryPublish(false)
        setDateValue(
          course.publish_date
            ? dayjs(course.publish_date).format("YYYY-MM-DDTHH:mm")
            : "",
        )
      })
  }

  const handleDateChange = (e) => {
    if (e.target.value === "") {
      handleClearDate()
    }
    setDateValue(e.target.value)
  }

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      flexWrap="wrap"
    >
      <Typography color="secondary" className={classes.inputLabel}>
        {!course.published ? "Publish Date" : "Published Date"}
      </Typography>
      <input
        className="bg-[#F4F4F4] p-2 rounded-md w-full"
        disabled={disabledSave || disablePicker}
        type="datetime-local"
        id="dateTimeInput"
        name="dateTimeInput"
        value={dateValue}
        min={dayjs().format("YYYY-MM-DDTHH:mm")}
        onChange={handleDateChange}
        onBlur={(e) => {
          if (
            dateValue &&
            dateValue !== dayjs(course.publish_date).format("YYYY-MM-DDTHH:mm")
          ) {
            handleDateSelection(e)
          }
        }}
      />
      {dateValue && !disablePicker ? (
        <Button
          variant="outlined"
          classes={{ root: classes.buttonRoot }}
          onClick={handleClearDate}
          style={{ marginLeft: "16px", height: "32px" }}
        >
          Cancel
        </Button>
      ) : null}
    </Box>
  )
}

DateTime.propTypes = {
  disablePicker: PropTypes.bool,
}

export default DateTime
